import { Inject, Injectable, forwardRef } from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }              from '../api/api.service';
import { ConfirmService }          from '../messages/confirm/confirm.service';
import { LoanCarVehicleComponent } from './loan-car.vehicle.component';
import { LoanCarVehicleModel }     from './typings/loan-car.vehicle';

@Injectable({
  providedIn: 'root'
})
export class LoanCarService {
  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService      : ApiService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  deleteLoanVehicle ( loanVehicle : LoanCarVehicleModel ) : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_LOAN_VEHICLE'))
    .then(() => this.apiService.delete('/loan_vehicle', loanVehicle.id));
  }

  manageLoanVehicle ( id : string ) : Promise<any> {
    return Promise.resolve()
    .then(() => id
      ? this.apiService.get('/loan_vehicle', id)
      : null
    )
    .then(( loanVehicle ) => {
      const modal = this.modalService.open(LoanCarVehicleComponent, {
        size: 'lg'
      });

      modal.componentInstance.loanVehicle = loanVehicle;

      return modal.result;
    });
  }

  saveVehicle ( loanVehicle : LoanCarVehicleModel ) : Promise<any> {
    return this.apiService.post('/loan_vehicles', loanVehicle, 'loan_vehicle');
  }

  updateVehicle ( loanVehicle : LoanCarVehicleModel ) : Promise<any> {
    return this.apiService.patch('/loan_vehicle', loanVehicle, 'loan_vehicle');
  }
}
